export const SEARCH_TAB_TRIGGER_CLASSNAME =
  'h-[2.8rem] flex-none gap-[0.8rem] rounded-[0.8rem] border-0 px-[1.2rem] py-0 medium5 text-white/54 shadow-none transition-colors hover:text-primary tablet:hover:bg-white/8 tablet:hover:text-primary dark:text-white/54 data-[state=active]:rounded-[1.2rem] data-[state=active]:pl-[1rem] data-[state=active]:bg-white/8 data-[state=active]:text-primary data-[state=active]:shadow-none dark:data-[state=active]:bg-white/8 dark:data-[state=active]:text-primary';

export const SEARCH_ACTION_TRIGGER_CLASSNAME =
  'w-[3.2rem] h-[3.2rem] shrink-0 rounded-[1rem] border-0 bg-white/10 hover:bg-white/16 dark:bg-white/10 dark:hover:bg-white/16 data-[state=open]:bg-white/16 [&_svg]:size-[1.6rem] [&_svg]:!text-primary';

export const SEARCH_SUBMENU_CLASSNAME =
  'max-h-[calc(var(--radix-dropdown-menu-content-available-height)-0.8rem)] overflow-y-auto';

export const SEARCH_SCROLL_LIST_CLASSNAME =
  'flex min-h-0 flex-col overflow-y-auto -mr-[2.4rem]';

export const SEARCH_SCROLL_FADE_TOP_CLASSNAME =
  'mask-t-from-[calc(100%-2.4rem)]';

export const SEARCH_SCROLL_FADE_BOTTOM_CLASSNAME =
  'mask-b-from-[calc(100%-2.4rem)]';

export const SEARCH_SCROLL_FADE_BOTH_CLASSNAME =
  'mask-y-from-[calc(100%-2.4rem)]';
